export const cdnPath = (path) => {
  // eslint-disable-next-line no-undef
  const tag = process.env.DATE_IMG_TAG
  if (tag) {
    return 'https://cdn.courseticket.com/mf/' + tag + path
  }
  return 'http://localhost:8081' + path
}
export const defaultRemoteVersion = 'rc'
export const localRemoteVersion = 'dev'
export const defaultRemoteHost = 'localhost'
export const dockerRemoteHost = 'host.docker.internal'

export const remoteHost = () =>
  // eslint-disable-next-line no-undef
  process.env.REMOTE_HOST || defaultRemoteHost

export const envVarOf = (mfName) => 'MF_' + mfName.replace('mf_', '').toUpperCase()

export const remoteVersionOf = (mfName) =>
  // eslint-disable-next-line no-undef
  process.env[envVarOf(mfName)] || defaultRemoteVersion

export const remoteUrl = (mfName, localPort, svCl) => {
  const customizableRemotes = {
    // eslint-disable-next-line no-undef
    mf_agents: process.env.MF_AGENTS,
    // eslint-disable-next-line no-undef
    mf_admin: process.env.MF_ADMIN,
    // eslint-disable-next-line no-undef
    mf_assessment: process.env.MF_ASSESSMENT,
    // eslint-disable-next-line no-undef
    mf_appBar: process.env.MF_APPBAR,
    // eslint-disable-next-line no-undef
    mf_checkout: process.env.MF_CHECKOUT,
    // eslint-disable-next-line no-undef
    mf_office: process.env.MF_OFFICE,
    // eslint-disable-next-line no-undef
    mf_public: process.env.MF_PUBLIC,
    // eslint-disable-next-line no-undef
    mf_reporting: process.env.MF_REPORTING,
    // eslint-disable-next-line no-undef
    mf_sme: process.env.MF_SME,
    // eslint-disable-next-line no-undef
    mf_user: process.env.MF_USER
  }
  // eslint-disable-next-line no-undef
  let DATE_IMG_TAG = process.env.DATE_IMG_TAG
  const remoteVersion = customizableRemotes?.[mfName] || defaultRemoteVersion
  if (DATE_IMG_TAG || remoteVersion !== localRemoteVersion) {
    if (!DATE_IMG_TAG) {
      DATE_IMG_TAG = remoteVersion
    }
    const domain = 'https://cdn.courseticket.com/mf/'
    return domain + DATE_IMG_TAG + '/' + mfName + '/' + svCl + '/'
  }
  const host = svCl === 'client' ? defaultRemoteHost : remoteHost()
  // eslint-disable-next-line no-console
  console.log(`🧩  Microfrontend loaded via "${host}" for ${svCl}: ${mfName}`)
  return 'http://' + host + ':' + localPort + '/' + svCl + '/'
}
export const remote = (mfName, localPort, svCl) => {
  return mfName + '@' + remoteUrl(mfName, localPort, svCl) + 'remoteEntry.js'
}
